module.exports = __webpack_public_path__ + "static/media/choropleth@2x.f11ac3c6.png";